import React from "react";
import "./footer.css";

const Footer = (props) => {
  return (
    <div className={"footer " + props.className} id='footer'>
      <div className="footergrid">
        <p className="footer-heading">Get In Touch</p>
        <p className="footer-content">
          I am looking for an opportunity to learn and enhance my skills.
        </p>
        <a href="mailto:abhijithpillai174@gmail.com"><button className="btn-footer">Say Hello</button></a>
      </div>

      <div className="copyright">
        <p className="designed">Designed and Built by &nbsp;<span>Abhijith Pillai</span></p>
      </div>
    </div>
  );
};

export default Footer;
